export { default as appStoreBadge } from '@ui/assets/app-store-badge.svg'
export { default as appStoreIcon } from '@ui/assets/app-store-icon.png'

export { default as arrowDownIcon } from '@ui/assets/arrow-down-icon.svg'
export { default as arrowForward } from '@ui/assets/arrow-forward.svg'
export { default as arrowLeft } from '@ui/assets/arrow-left.svg'
export { default as arrowRight } from '@ui/assets/arrow-right.svg'

export { default as athletaLogo } from '@ui/assets/athleta-logo.svg'

export { default as atmLogoWhite } from '@ui/assets/atm-logo-white.svg'
export { default as atmLogo } from '@ui/assets/atm-logo.svg'

export { default as atomMeditating } from '@ui/assets/atom-meditating.png'
export { default as atomPointing } from '@ui/assets/atom-pointing.png'
export { default as atomThumbsUp } from '@ui/assets/atom-thumbs-up.svg'

export { default as bankIcon } from '@ui/assets/bank-icon.svg'

export { default as bloombergLogo } from '@ui/assets/bloomberg-logo.svg'

export { default as blueBlobAntenna } from '@ui/assets/blue-blob-antenna.png'
export { default as blueBlobBody } from '@ui/assets/blue-blob-body.png'
export { default as blueBlobCharacter } from '@ui/assets/blue-blob-character.png'
export { default as blueBlobEllipse } from '@ui/assets/blue-blob-ellipse.svg'
export { default as blueBlobMask1 } from '@ui/assets/blue-blob-mask-1.svg'
export { default as blueBlobMask2 } from '@ui/assets/blue-blob-mask-2.svg'

export { default as checkIcon } from '@ui/assets/check-icon.svg'
export { default as checkmarkBlueIcon } from '@ui/assets/checkmark-blue-icon.svg'
export { default as checkmarkIcon2 } from '@ui/assets/checkmark-icon-2.svg'
export { default as checkmarkIcon3 } from '@ui/assets/checkmark-icon-3.svg'
export { default as checkmarkIcon4 } from '@ui/assets/checkmark-icon-4.svg'
export { default as checkmarkIcon } from '@ui/assets/checkmark-icon.svg'

export { default as closeIcon } from '@ui/assets/close-icon.svg'

export { default as coupleBeach } from '@ui/assets/couple-beach.png'
export { default as coupleSecurityEllipse } from '@ui/assets/couple-security-ellipse.png'

export { default as currencyExchangeIcon } from '@ui/assets/currency-exchange-icon.svg'

export { default as decorativeCurves } from '@ui/assets/decorative-curves.svg'
export { default as decorativeLinesSmall } from '@ui/assets/decorative-lines-small.svg'
export { default as decorativeLines } from '@ui/assets/decorative-lines.svg'

export { default as ellipseInstantCashBg } from '@ui/assets/ellipse-instant-cash-bg.png'
export { default as ellipsePersonalizedBg2 } from '@ui/assets/ellipse-personalized-bg-2.png'
export { default as ellipsePersonalizedBg } from '@ui/assets/ellipse-personalized-bg.png'
export { default as ellipsePersonalizedReal } from '@ui/assets/ellipse-personalized-real.png'
export { default as ellipsePersonalized } from '@ui/assets/ellipse-personalized.svg'
export { default as ellipseSecurityReal } from '@ui/assets/ellipse-security-real.png'
export { default as ellipseSecurity } from '@ui/assets/ellipse-security.svg'
export { default as ellipseSteps } from '@ui/assets/ellipse-steps.svg'

export { default as facebookIcon } from '@ui/assets/facebook-icon.svg'

export { default as fastCompanyLogo } from '@ui/assets/fast-company-logo.svg'

export { default as footerBgPattern } from '@ui/assets/footer-bg-pattern.svg'

export { default as forbesLogo } from '@ui/assets/forbes-logo.svg'

export { default as gamingIcon } from '@ui/assets/gaming-icon.svg'

export { default as globeIcon } from '@ui/assets/globe-icon.svg'

export { default as googlePlayBadge } from '@ui/assets/google-play-badge.svg'
export { default as googlePlayIcon } from '@ui/assets/google-play-icon.png'

export { default as heartSmileIcon } from '@ui/assets/heart-smile-icon.svg'

export { default as instagramIcon } from '@ui/assets/instagram-icon.svg'

export { default as iphoneApproval100 } from '@ui/assets/iphone-approval-100.png'
// iphone-approval-100 with the transparent margins cropped off (alpha bbox
// + 16px). Use when the layout sizes the image box and the padding would
// shrink the visible phone; the original stays untouched for existing uses.
export { default as iphoneApproval100Trimmed } from '@ui/assets/iphone-approval-100-trimmed.png'

export { default as languageIcon } from '@ui/assets/language-icon.svg'

export { default as linkedinIcon } from '@ui/assets/linkedin-icon.svg'

export { default as lockIcon } from '@ui/assets/lock-icon.svg'

export { default as lunchIcon } from '@ui/assets/lunch-icon.svg'

export { default as newYorkerLogo } from '@ui/assets/new-yorker-logo.svg'

export { default as passwordStars } from '@ui/assets/password-stars.svg'

export { default as person1 } from '@ui/assets/person-1.png'
export { default as person2 } from '@ui/assets/person-2.png'
export { default as person3 } from '@ui/assets/person-3.png'
export { default as personOverlay } from '@ui/assets/person-overlay.png'
export { default as personPhoneYellow } from '@ui/assets/person-phone-yellow.png'

export { default as phoneFrame } from '@ui/assets/phone-frame.png'
export { default as phoneHand100 } from '@ui/assets/phone-hand-100.svg'

export { default as plusIcon } from '@ui/assets/plus-icon.svg'

export { default as profile1 } from '@ui/assets/profile-1.png'
export { default as profile2 } from '@ui/assets/profile-2.png'
export { default as profile3 } from '@ui/assets/profile-3.png'
export { default as profile4 } from '@ui/assets/profile-4.png'

export { default as rewardsMask } from '@ui/assets/rewards-mask.svg'

export { default as robinhoodLogo } from '@ui/assets/robinhood-logo.svg'

export { default as speechBubbleTail } from '@ui/assets/speech-bubble-tail.svg'

export { default as squigglyArrowDecoration } from '@ui/assets/squiggly-arrow-decoration.svg'
export { default as squigglyDecoration } from '@ui/assets/squiggly-decoration.svg'

export { default as starDecoration } from '@ui/assets/star-decoration.svg'

export { default as starbucksLogo } from '@ui/assets/starbucks-logo.svg'

export { default as stashLogo } from '@ui/assets/stash-logo.svg'

export { default as taskrabbitLogo } from '@ui/assets/taskrabbit-logo.svg'

export { default as testimonialsBg } from '@ui/assets/testimonials-bg.png'

export { default as tiktokIcon } from '@ui/assets/tiktok-icon.svg'

export { default as uberIcon } from '@ui/assets/uber-icon.svg'
export { default as uberLogo } from '@ui/assets/uber-logo.svg'

export { default as walmartLogo } from '@ui/assets/walmart-logo.svg'
export { default as walmartSpark } from '@ui/assets/walmart-spark.svg'

export { default as wiredLogo } from '@ui/assets/wired-logo.svg'

export { default as womanPhoneEllipse } from '@ui/assets/woman-phone-ellipse.png'

export { default as xIcon } from '@ui/assets/x-icon.svg'

export { default as youtubeIcon } from '@ui/assets/youtube-icon.svg'
